import Paperclip from '@assets/icons/paperclip.svg'
import { Icon } from './Icon'

export const PaperclipIcon = Icon(Paperclip)
